module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-material-ui/gatsby-browser.js'),
      options: {"plugins":[],"stylesProvider":{"injectFirst":true}},
    },{
      plugin: require('../node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"","short_name":"","icon":"/Users/challen/code/element-tracker/example/node_modules/@cs125/gatsby-theme-cs125/src/images/logo.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"f25d706569b844cbb70f4d1b4fa67ac4"},
    },{
      plugin: require('../node_modules/@cs125/gatsby-theme-cs125/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
